import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {SearchSubjectsAction, userDetailAction} from '../action';

function* execute({payload}: SearchSubjectsAction): SagaIterator {
    const response = yield* call(Api.searchSubjects, {text: payload});

    if (response.isSuccess) {
        yield* put(userDetailAction.setSubjectsOptions(response.data));
    } else {
        yield putAll(showBeError(response, t('userDetail')('subjectsLoading')));
    }
}

export function* searchSubjectsSaga(): SagaIterator {
    yield takeLatestF('userDetail/SEARCH_SUBJECTS', execute);
}
